import { render, staticRenderFns } from "./ButtonSpinner.vue?vue&type=template&id=3006e3cc&"
import script from "./ButtonSpinner.vue?vue&type=script&lang=js&"
export * from "./ButtonSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports